var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import {} from '@blocksuite/blocks';
import { DisposableGroup } from '@blocksuite/global/utils';
import { ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { css, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { FrameCardTitleEditor } from './frame-card-title-editor.js';
const styles = css `
  .frame-card-title-container {
    display: flex;
    white-space: nowrap;
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 20px;
    box-sizing: border-box;
    gap: 6px;
    font-size: var(--affine-font-sm);
    cursor: default;
    position: relative;
  }

  .frame-card-title-container .card-index {
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    box-sizing: border-box;
    border-radius: 2px;
    background: var(--affine-black);
    margin-left: 2px;

    color: var(--affine-white);
    text-align: center;
    font-weight: 500;
    line-height: 18px;
  }

  .frame-card-title-container .card-title {
    height: 20px;
    color: var(--affine-text-primary-color);
    font-weight: 400;
    line-height: 20px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }
`;
export class FrameCardTitle extends WithDisposable(ShadowlessElement) {
    constructor() {
        super(...arguments);
        this._titleDisposables = null;
        this._updateElement = () => {
            this.requestUpdate();
        };
        this._mountTitleEditor = (e) => {
            e.stopPropagation();
            const titleEditor = new FrameCardTitleEditor();
            titleEditor.frameModel = this.frame;
            titleEditor.titleContentElement = this.titleContentElement;
            const left = this.titleIndexElement.offsetWidth + 6;
            titleEditor.left = left;
            titleEditor.maxWidth = this.titleContainer.offsetWidth - left - 6;
            this.titleContainer.appendChild(titleEditor);
        };
        this._clearTitleDisposables = () => {
            this._titleDisposables?.dispose();
            this._titleDisposables = null;
        };
    }
    _setFrameDisposables(title) {
        this._clearTitleDisposables();
        title.observe(this._updateElement);
        this._titleDisposables = new DisposableGroup();
        this._titleDisposables.add({
            dispose: () => {
                title.unobserve(this._updateElement);
            },
        });
    }
    updated(_changedProperties) {
        if (_changedProperties.has('frame')) {
            this._setFrameDisposables(this.frame.title.yText);
        }
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._clearTitleDisposables();
    }
    render() {
        return html `<div class="frame-card-title-container">
      <div
        class="card-index"
        @click=${(e) => e.stopPropagation()}
        @dblclick=${(e) => e.stopPropagation()}
      >
        ${this.cardIndex + 1}
      </div>
      <div class="card-title">
        <span
          @click=${(e) => e.stopPropagation()}
          @dblclick=${this._mountTitleEditor}
          >${this.frame.title}</span
        >
      </div>
    </div>`;
    }
}
FrameCardTitle.styles = styles;
__decorate([
    property({ attribute: false })
], FrameCardTitle.prototype, "frame", void 0);
__decorate([
    property({ attribute: false })
], FrameCardTitle.prototype, "cardIndex", void 0);
__decorate([
    query('.frame-card-title-container')
], FrameCardTitle.prototype, "titleContainer", void 0);
__decorate([
    query('.frame-card-title-container .card-index')
], FrameCardTitle.prototype, "titleIndexElement", void 0);
__decorate([
    query('.frame-card-title-container .card-title')
], FrameCardTitle.prototype, "titleContentElement", void 0);
//# sourceMappingURL=frame-card-title.js.map